var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "排序设置",
        visible: _vm.dialogVisible,
        width: "60%",
        "before-close": _vm.handleClose,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "sortWrap",
        },
        [
          _c(
            "div",
            { staticClass: "sort-table" },
            [
              _c("div", { staticClass: "sort-header" }, [
                _c("div", { staticClass: "sort-cell sort-index" }, [
                  _vm._v("序号"),
                ]),
                _c("div", { staticClass: "sort-cell" }, [_vm._v("客户")]),
                _c("div", { staticClass: "sort-cell sort-operate" }, [
                  _vm._v("操作"),
                ]),
              ]),
              _c(
                "draggable",
                {
                  attrs: {
                    handle: ".drag-icon",
                    animation: "150",
                    "ghost-class": "sortable-ghost",
                  },
                  model: {
                    value: _vm.sortData,
                    callback: function ($$v) {
                      _vm.sortData = $$v
                    },
                    expression: "sortData",
                  },
                },
                _vm._l(_vm.sortData, function (item, index) {
                  return _c("div", { key: item.id, staticClass: "sort-row" }, [
                    _c("div", { staticClass: "sort-cell sort-index" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _c("div", { staticClass: "sort-cell" }, [
                      _vm._v(_vm._s(item.member_name || "-")),
                    ]),
                    _c("div", { staticClass: "sort-cell sort-operate" }, [
                      _c("span", { staticClass: "drag-icon" }, [
                        _c("i", { staticClass: "el-icon-rank" }),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveSort } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }